import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ProgrammeCardData } from '@app/core/programme/programme-card';

@Component({
  selector: 'app-programme-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './programme-card.html',
  host: { class: 'block h-full' },
  imports: [RouterLink],
})
export class ProgrammeCard {
  readonly programme = input.required<ProgrammeCardData>();
}
